import React, { useState, useEffect } from "react";

import { coursesApi as courses } from "api";
import StatusScreen, { Loading } from "components/StatusScreen";
import { formatNumber } from "lib/format";

export default function Joined({ history, match }) {
  const [state, setstate] = useState(() => ({
    isLoading: true,
    isError: false,
    data: {},
  }));

  const joining = React.useCallback(async () => {
    try {
      const details = await courses.details(match.params.class);

      const joined = await courses.join(match.params.class);
      if (joined.data.snap_url) window.location.href = joined.data.snap_url;
      // No payment gateway: the order waits until an admin confirms the payment.
      else if (joined.data.payment?.method === "manual")
        setstate({ isLoading: false, isError: false, data: details, order: joined.data });
      // Free class: skip the success screen and open lesson 1 right away.
      else if (details?.type === "free")
        history.replace(`/courses/${match.params.class}`);
      else setstate({ isLoading: false, isError: false, data: details });
    } catch (error) {
      if (error?.response?.data?.message === "user already take this course")
        history.push(`/courses/${match.params.class}`);
      else
        setstate({
          isLoading: false,
          isError: true,
          message:
            error?.response?.data?.message ??
            "Could not join this class right now. Please try again later.",
        });
    }
  }, [match.params.class, history]);

  useEffect(() => {
    joining();
  }, [joining]);

  if (state.isLoading) return <Loading />;
  if (state.isError)
    return (
      <StatusScreen title="Could not join this class" action={{ to: "/", label: "Back to My Class" }}>
        {typeof state.message === "string" ? state.message : "Could not join this class right now. Please try again later."}
      </StatusScreen>
    );

  if (state.order)
    return (
      <StatusScreen title="Almost there" action={{ to: "/transactions", label: "See my orders" }}>
        <p>
          Your order <strong>#{state.order.id}</strong> for <strong>{state.data?.name ?? "this class"}</strong> is
          waiting for payment of <strong>RM {formatNumber(state.order.payment.amount)}</strong>.
        </p>
        <p className="yc-status-note">{state.order.payment.instructions}</p>
        <p>Your class opens here as soon as we confirm the payment.</p>
      </StatusScreen>
    );

  return (
    <StatusScreen
      image="illustration-joined.jpg"
      title="Welcome to Class"
      action={{ to: `/courses/${match.params.class}`, label: "Start learning" }}
    >
      You have successfully joined our <strong>{state?.data?.name ?? "Class Name"}</strong> class.
    </StatusScreen>
  );
}
